"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    compose: function() {
        return compose;
    },
    pipe: function() {
        return pipe;
    }
});
const compose = (...fns)=>(x)=>fns.reduceRight((v, f)=>f(v), x);
const pipe = (...functions)=>(value)=>{
        return functions.reduce((currentValue, currentFunction)=>{
            return currentFunction(currentValue);
        }, value);
    } // https://www.freecodecamp.org/news/pipe-and-compose-in-javascript-5b04004ac937/
     // pipe(
     //   getName,
     //   uppercase,
     //   get6Characters,
     //   reverse
     // )({ name: 'Buckethead' });
;
